export default "__VITE_ASSET__f8259a80__"